import axios from "axios";

const RAW_API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";
const NORMALIZED_API_URL = RAW_API_URL.replace(/\/+$/, "");
const API_BASE_URL = NORMALIZED_API_URL.endsWith("/api")
  ? NORMALIZED_API_URL
  : `${NORMALIZED_API_URL}/api`;

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Auth API
export const authAPI = {
  signup: (data) => api.post("/auth/signup", data),
  login: (data) => api.post("/auth/login", data),
  getMe: () => api.get("/auth/me"),
  forgotPassword: (data) => api.post("/auth/forgot-password", data),
  resetPassword: (data) => api.post("/auth/reset-password", data),
  changePassword: (data) => api.post("/auth/change-password", data),
  googleLogin: (data) => api.post("/auth/google", data),
};

// Profile API
export const profileAPI = {
  createOrUpdate: (data) => api.post("/profile", data),
  getMyProfile: () => api.get("/profile/me"),
  getProfileByUserId: (userId) => api.get(`/profile/${userId}`),
  uploadPhoto: (formData) => {
    return api.post("/profile/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  deletePhoto: (photoUrl) =>
    api.delete("/profile/photo", { data: { photoUrl } }),
  deleteProfile: () => api.delete("/profile/delete"),
};

// Discovery API
export const discoveryAPI = {
  getNextProfile: () => api.get("/discovery"),
};

// Swipe API
export const swipeAPI = {
  skip: (skippedUserId) => api.post("/swipe/skip", { skippedUserId }),
  like: (likedUserId) => api.post("/swipe/like", { likedUserId }),
  getSwipeStatus: (targetUserId) => api.get(`/swipe/status/${targetUserId}`),
};

// Match API
export const matchAPI = {
  getMatches: () => api.get("/matches"),
  getMatchById: (matchId) => api.get(`/matches/${matchId}`),
  getChatList: () => api.get("/chat"),
};

// Chat API
export const chatAPI = {
  sendMessage: (data) => api.post("/chat/send", data),
  getMessages: (matchId) => api.get(`/chat/${matchId}`),
  markAsRead: (matchId) => api.post("/chat/read", { matchId }),
  getUnreadCount: () => api.get("/chat/unread-count"),
  markChatAsRead: (matchId) => api.put(`/chat/mark-read/${matchId}`),
};

// Gift API
export const giftAPI = {
  getGifts: () => api.get("/gifts"),
  sendGift: (data) => api.post("/gifts/send", data),
  getReceivedGifts: () => api.get("/gifts/received"),
  getSentGifts: () => api.get("/gifts/sent"),
};

// Payment API
export const paymentAPI = {
  createPaymentIntent: (amountInPaise) =>
    api.post("/payments/create-intent", { amountInPaise }),
  confirmPayment: (paymentIntentId) =>
    api.post("/payments/confirm", { paymentIntentId }),
  getPaymentHistory: () => api.get("/payments/history"),
};

// Notification API
export const notificationAPI = {
  getUnreadCount: () => api.get("/notifications/count"),
  getNotifications: () => api.get("/notifications"),
  markAsRead: (notificationIds) =>
    api.put("/notifications/mark-read", { notificationIds }),
  markAllAsRead: () => api.put("/notifications/mark-read", {}),
};

export default api;
